import { useState } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { toast } from "react-toastify";
import InputField from "../../../../atoms/InputField";
import TemplateForm from "../../../../atoms/TemplateForm";
import { REGISTER_FACTURA } from "../../../../../api/apiFacturas";

const CreateFactura = ({ onClose, refetch, inmueble }) => {
    const [ , setArchivo] = useState({ file: null });

    const initialValues = {
        date: "",
        file: null,
        propertieId:  inmueble.id,
        userId: inmueble.userId,
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            await REGISTER_FACTURA(values);
            refetch();
            onClose();
            toast.success("Agregado exitosamente");
        } catch (error) {
            console.error(error);
            toast.error("Error al registrar la factura");
        } finally {
            setSubmitting(false);
        }
    };

    const validationSchema = Yup.object({
        date: Yup.string().required("Nombre es requerido"),
        file: Yup.mixed().required("La factura es obligatoria"),
    });

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
            {({ values, isSubmitting, setFieldValue }) => (
                <TemplateForm
                    fields={
                        <>
                            <InputField
                                name="file"
                                label="Factura"
                                type="file"
                                onChange={(e) => {
                                    const file = e.currentTarget.files?.[0] || null;
                                    setFieldValue("file", file);
                                    setArchivo((prev) => ({ ...prev, file: file }));
                                }}
                            />
                            <InputField name="date" label="Fecha" type="date"/>
                        </>
                    }
                    isSubmitting={isSubmitting}
                    textButton="Aceptar"
                />
            )}
        </Formik>
    );
};

export default CreateFactura;